import React from "react";
import PlantList from "../organisms/Enterprise/PlantList";
import LoginScreen from "../screens/LoginScreen";
import RegisterScreen from "../screens/RegisterScreen";
import CompanyScreen from "../screens/Enterprise/Company";
import { Box, Icon } from "@mui/material";
import HomeScreen from "../screens/Home";
import ProviderScreen from "../screens/Providers/ProviderScreen.tsx";
import CataloguesScreen from "../screens/Catalogues";
import ProductScreen from "../screens/Products";
import ShipmentScreen from "../screens/Imports/ShipmentScreen";
import DashboardLayout from "../layouts/DashboardLayout";
import PurchaseOrderScreen from "../screens/PurchaseOrders/PurchaseOrderScreen";
import PODetailScreen from "../screens/PurchaseOrders/PODetailScreen";
import AssetScreen from "../screens/Catalogues/AssetScreen";
import ManageUsersScreen from "../screens/Auth/ManageUsersScreen";
import RAScreen from "../screens/ReceiptAcknowledgement/RAScreen";
import ClientScreen from "../screens/Clients/ClientScreen.tsx";
import ClientWarehouseScreen from "../screens/Clients/ClientWarehouseScreen.tsx";
import FinishedGoodScreen from "../screens/FinishedGoods/FinishedGoodScreen";
import ExportForm from "../organisms/Exports/ExportForm";
import ExportScreen from "../screens/Exports/ExportScreen";
import ExportDetailScreen from "../screens/Exports/ExportDetailScreen";
import ClientPurchaseOrderScreen from "../screens/CPO/ClientPurchaseOrderScreen";
import PaymentScreen from "../screens/Payments/PaymentScreen";
import PaymentsV2Screen from "../screens/Payments/PaymentsV2Screen";
import ApprovalScreen from "../screens/Approvals/ApprovalScreen.tsx";
import RolesScreen from "../screens/Auth/RolesScreen";
import InboundForm from "../organisms/Inventory/InboundForm.tsx";
import InventoryScreen from "../screens/Inventory/InventoryScreen.tsx";
import InventoryApprovalScreen from "../screens/Inventory/InventoryApprovalScreen.tsx";
import PICDashboardScreen from "../screens/Inventory/PICDashboardScreen.tsx";
import QuotingScreen from "../screens/Quoting/QuotingScreen.tsx";
import QuotingWizardScreen from "../screens/Quoting/QuotingWizardScreen.tsx";
import ResetPasswordScreen from "../screens/Auth/ResetPasswordScreen";
import ForgotPasswordScreen from "../screens/Auth/ForgotPasswordScreen";
import QualityControlScreen from "../screens/QualityControl/QualityControlScreen";
import WorkOrderScreen from "../screens/WorkOrders/WorkOrderScreen";
import CurrencyVisualizerScreen from "../screens/CurrencyVisualizer/CurrencyVisualizerScreen";
import PlaceholderForm from "../organisms/Placeholder/PlaceholderForm.tsx";
import InventoryTagTestForm from "../organisms/Inventory/InventoryTagTestForm.tsx";
import SandboxScreen from "../screens/Lab/SandboxScreen";
import AccountingInventoryScreen from "../screens/Inventory/AccountingInventoryScreen.tsx";
import ProductRequestApprovalScreen from "../screens/ProductRequests/ProductRequestApprovalScreen.tsx";
import ReportesScreen from "../screens/Reportes/ReportesScreen";
import ApFlowScreen from "../screens/AccountsPayable/ApFlowScreen";

const baseRoles = ["Superadmin", "Admin"];

const ENV = process.env.REACT_APP_ENV;

/** Side-nav menu family definitions (order = display order). */
export const menuFamilies = [
  { id: "usuarios", title: "Usuarios", icon: <Icon>group</Icon> },
  { id: "aprobaciones", title: "Aprobaciones", icon: <Icon>fact_check</Icon> },
  { id: "inventario", title: "Inventario", icon: <Icon>inventory_2</Icon> },
  { id: "compras", title: "Compras", icon: <Icon>shopping_cart</Icon> },
  { id: "clientes", title: "Clientes", icon: <Icon>people</Icon> },
  { id: "cuentas-por-pagar", title: "Cuentas por pagar", icon: <Icon>account_balance_wallet</Icon> },
  { id: "comercio-exterior", title: "Comercio exterior", icon: <Icon>public</Icon> },
  { id: "operaciones", title: "Operaciones", icon: <Icon>precision_manufacturing</Icon> },
  { id: "contabilidad", title: "Contabilidad", icon: <Icon>account_balance</Icon> },
  { id: "administracion", title: "Administración", icon: <Icon>settings</Icon> },
  { id: "laboratorio", title: "Laboratorio", icon: <Icon>science</Icon> },
];

const routes = [
  {
    path: "/",
    element: <LoginScreen />,
  },
  {
    path: "/login",
    element: <LoginScreen />,
  },
  {
    path: "/approvals",
    element: <ApprovalScreen />,
    roles: baseRoles,
    menu: {
      title: "Aprobar órdenes de compra",
      icon: <Icon>check_circle</Icon>,
      family: "aprobaciones",
    },
  },
  {
    path: "/product-requests/approvals",
    element: <ProductRequestApprovalScreen />,
    roles: ["Superadmin"],
    menu: {
      title: "Aprobar solicitudes de apartado",
      icon: <Icon>inventory_2</Icon>,
      family: "aprobaciones",
    },
  },
  {
    path: "/register",
    element: <RegisterScreen />,
    roles: ["Superadmin"],
    menu: {
      title: "Registrar usuario",
      icon: <Icon>person_add</Icon>,
      family: "usuarios",
    },
  },
  {
    path: "/user-config",
    element: <ManageUsersScreen />,
    roles: baseRoles,
    menu: {
      title: "Administrar usuarios",
      icon: <Icon>manage_accounts_icon</Icon>,
      family: "usuarios",
    },
  },
  {
    path: "/roles",
    element: <RolesScreen />,
    roles: ["Superadmin"],
    menu: {
      title: "Administrar roles",
      icon: <Icon>admin_panel_settings</Icon>,
      family: "usuarios",
    },
  },
  {
    path: "/home",
    element: <HomeScreen />,
    roles: baseRoles,
  },
  {
    path: "/providers",
    element: <ProviderScreen />,
    roles: [...baseRoles, "Compras", "Cuentas por pagar", "Planeacion", "Contador", "Auxiliar Contable"],
    menu: {
      title: "Proveedores",
      icon: <Icon>warehouse</Icon>,
      family: "compras",
    },
  },
  {
    path: "/clients",
    element: <ClientScreen />,
    roles: [...baseRoles],
    menu: {
      title: "Clientes",
      icon: <Icon>person</Icon>,
      family: "clientes",
    },
  },
  {
    path: "/client-warehouses",
    element: <ClientWarehouseScreen />,
    roles: [...baseRoles],
    menu: {
      title: "Almacenes de clientes",
      icon: <Icon>store</Icon>,
      family: "clientes",
    },
  },
  {
    path: "/products",
    element: <ProductScreen />,
    roles: [...baseRoles, "Compras", "Cuentas por pagar", "Planeacion", "Supervisor de Almacen General", "Auxiliar Almacén"],
    menu: {
      title: "Productos",
      icon: <Icon>business_center</Icon>,
      family: "inventario",
    },
  },
  {
    path: "/finished-goods",
    element: <FinishedGoodScreen />,
    roles: baseRoles,
    menu: {
      title: "Productos terminados",
      icon: <Icon>business_center</Icon>,
      family: "inventario",
    },
  },
  {
    path: "/purchase-orders",
    element: <PurchaseOrderScreen />,
    roles: [...baseRoles, "Compras", "Cuentas por pagar", "Planeacion"],
    menu: {
      title: "Órdenes de compra",
      icon: <Icon>shopping_bag</Icon>,
      family: "compras",
    },
  },
  {
    path: "/client-purchase-orders",
    element: <ClientPurchaseOrderScreen />,
    roles: [...baseRoles],
    menu: {
      title: "Órdenes de compra de clientes",
      icon: <Icon>shopping_bag</Icon>,
      family: "clientes",
    },
  },
  {
    path: "/receipt-acknowledgements",
    element: <RAScreen />,
    roles: [...baseRoles, "Contador", "Auxiliar Contable"],
    menu: {
      title: "Contrarrecibos",
      icon: <Icon>receipt_long</Icon>,
      family: "cuentas-por-pagar",
    },
  },
  {
    path: "/payments",
    element: <PaymentScreen />,
    roles: [...baseRoles, "Contador", "Cuentas por pagar", "Auxiliar Contable"],
    menu: {
      title: "Pagos",
      icon: <Icon>payments</Icon>,
      family: "cuentas-por-pagar",
    },
  },
  {
    path: "/scheduled-payments",
    element: <PaymentsV2Screen />,
    roles: [...baseRoles, "Contador", "Cuentas por pagar", "Auxiliar Contable"],
    menu: {
      title: "Pagos V2",
      icon: <Icon>schedule_send</Icon>,
      family: "cuentas-por-pagar",
    },
  },
  {
    path: "/accounts-payable/flow",
    element: <ApFlowScreen />,
    roles: [...baseRoles, "Contador", "Cuentas por pagar", "Auxiliar Contable"],
    menu: {
      title: "Flujo de CxP",
      icon: <Icon>account_tree</Icon>,
      family: "cuentas-por-pagar",
    },
  },
  {
    path: "/purchase-orders/concepts",
    element: <PODetailScreen />,
    roles: [...baseRoles, "Compras"],
  },
  {
    path: "/imports",
    element: <ShipmentScreen />,
    roles: [...baseRoles, "Importacion"],
    menu: {
      title: "Importaciones",
      icon: <Icon>flight_land</Icon>,
      family: "comercio-exterior",
    },
  },
  {
    path: "/exports",
    element: <ExportScreen />,
    roles: [...baseRoles],
    menu: {
      title: "Exportaciones",
      icon: <Icon>flight_takeoff</Icon>,
      family: "comercio-exterior",
    },
  },
  {
    path: "/exports/items",
    element: <ExportDetailScreen />,
    roles: [...baseRoles],
  },
  {
    path: "/plants",
    element: <PlantList />,
    roles: [...baseRoles, "User"],
  },
  {
    path: "/enterprise",
    element: <CompanyScreen />,
    roles: ["Superadmin"],
    menu: {
      title: "Empresa",
      icon: <Icon>factory</Icon>,
      family: "administracion",
    },
  },
  {
    path: "/catalogues",
    element: <CataloguesScreen />,
    roles: [...baseRoles, "Contador", "Auxiliar Contable"],
    menu: {
      title: "Catálogos",
      icon: <Icon>all_inbox</Icon>,
      family: "contabilidad",
    },
  },
  {
    path: "/assets",
    element: <AssetScreen />,
    roles: baseRoles,
    menu: {
      title: "Activos",
      icon: <Icon>emoji_transportation_icon</Icon>,
      family: "inventario",
    },
  },
  {
    path: "/unauthorized",
    element: <PlantList />,
    roles: ["User"],
  },
  {
    path: "/inventory",
    element: <InventoryScreen />,
    roles: [...baseRoles, "Almacen", "Supervisor de Almacen General", "Auxiliar Almacén"],
    menu: {
      title: "Inventario",
      icon: <Icon>inventory</Icon>,
      family: "inventario",
    },
  },
  {
    path: "/inventory-approvals",
    element: <InventoryApprovalScreen />,
    roles: [...baseRoles],
    menu: {
      title: "Aprobaciones de Inventario",
      icon: <Icon>inventory_2</Icon>,
      family: "aprobaciones",
    },
  },
  {
    path: "/accounting-inventory",
    element: <AccountingInventoryScreen />,
    roles: [...baseRoles, "Contador", "Auxiliar Contable"],
    menu: {
      title: "Inventario Contable",
      icon: <Icon>account_balance</Icon>,
      family: "contabilidad",
    },
  },
  {
    path: "/physical-inventory-counts/dashboard/:id",
    element: <PICDashboardScreen />,
    roles: [...baseRoles, "Almacen", "Supervisor de Almacen General", "Auxiliar Almacén"],
  },
  {
    path: "/quality-control",
    element: <QualityControlScreen />,
    roles: [...baseRoles, "Inspector de Calidad"],
    menu: {
      title: "Control de Calidad",
      icon: <Icon>verified_user</Icon>,
      family: "operaciones",
    },
  },
  {
    path: "/quoting",
    element: <QuotingScreen />,
    roles: [...baseRoles, "Cotización"],
    menu: {
      title: "Cotizaciones",
      icon: <Icon>request_quote</Icon>,
      family: "operaciones",
    },
  },
  {
    path: "/quotingDetail",
    element: <QuotingWizardScreen />,
    roles: [...baseRoles],
  },
  {
    path: "/reset-password",
    element: <ResetPasswordScreen />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordScreen />,
  },
  {
    path: "/work-orders",
    element: <WorkOrderScreen />,
    roles: [...baseRoles, "Planeacion"],
    menu: {
      title: "Órdenes de Trabajo",
      icon: <Icon>assignment</Icon>,
      family: "operaciones",
    },
  },
  {
    path: "/currency-visualizer",
    element: <CurrencyVisualizerScreen />,
    roles: [...baseRoles, "Contador", "Auxiliar Contable", "Compras"],
    menu: {
      title: "Tipos de Cambio",
      icon: <Icon>trending_up</Icon>,
      family: "contabilidad",
    },
  },
  {
    path: "/reportes",
    element: <ReportesScreen />,
    roles: baseRoles,
    menu: {
      title: "Reportes",
      icon: <Icon>assessment</Icon>,
      family: "administracion",
    },
  },
];

if (ENV == "LOCAL") {
  routes.push({
    path: "/lab",
    element: (
      <DashboardLayout>
        <Box sx={{ p: 8 }}>
          <PlaceholderForm
            companyId={1}
            onSubmit={() => console.log("Form submitted")}
          />
        </Box>
      </DashboardLayout>
    ),
    roles: baseRoles,
    menu: {
      title: "Laboratorio",
      icon: <Icon>science</Icon>,
      family: "laboratorio",
    },
  });
  routes.push({
    path: "/lab/inventory-tag-test",
    element: (
      <DashboardLayout>
        <Box sx={{ p: 8 }}>
          <InventoryTagTestForm />
        </Box>
      </DashboardLayout>
    ),
    roles: baseRoles,
    menu: {
      title: "Probar Marbete Individual",
      icon: <Icon>label</Icon>,
      family: "laboratorio",
    },
  });
  routes.push({
    path: "/lab/sandbox",
    element: (
      <DashboardLayout>
        <Box sx={{ p: 8 }}>
          <SandboxScreen />
        </Box>
      </DashboardLayout>
    ),
    roles: baseRoles,
    menu: {
      title: "Sandbox Exportaciones",
      icon: <Icon>science</Icon>,
      family: "laboratorio",
    },
  });
}

export default routes;
